export default __webpack_public_path__ + "static/2-ca36cb9d251bfca5b0e7f5c7f1800bf7.webp";